import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
  Chip,
  Stack,
} from "@mui/material";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import API_URL from "../../src/Config";
import "./Form.css";
import "./permitViewPage.css";
import { IoArrowBackCircle } from "react-icons/io5";

function PermitViewPage({ isSidebarExpanded, fetchComplitionSatusData }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [request_status, setRequest_status] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { permit_id, permit_type_id, work_permit_name, wp_status } =
    useParams();

  const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleReasonChange = (e) => setReason(e.target.value);

  const handleRejectClick = () => setIsPopupOpen(true);

  const handleApproveConfirm = () => setIsApprovePopupOpen(true);

  const handleRejectConfirm = () => {
    handleRejectClick();
    setShowRejectPopup(false);
  };

  const closeApprovePopup = () => setIsApprovePopupOpen(false);

  const confirmApprove = () => {
    handleSaveClick();
    setIsApprovePopupOpen(false);
  };

  const closePopup = () => setIsPopupOpen(false);

  // Form 1 States (Read-only)
  const [form1Data, setForm1Data] = useState({
    workPermitName: "",
    formData: {},
    dynamicSubFields: [],
    fields: [],
    dateValues: {},
    selectedOptions: {},
    equipmentDetails: [],
  });

  // Form 2 States (Interactive) - Simplified to handle all fields dynamically
  const [checklistItems, setChecklistItems] = useState({});
  const [status, setStatus] = useState({});
  const [dynamicInputFields, setDynamicInputFields] = useState({});
  const [dynamicInputValues, setDynamicInputValues] = useState({});
  const [dynamicDropdownFields, setDynamicDropdownFields] = useState({});
  const [dynamicDropdownValues, setDynamicDropdownValues] = useState({});
  const [isNewChecklist, setIsNewChecklist] = useState(false);
  const [reason, setReason] = useState("");

  // Form 3 States (Read-only)
  const [form3Data, setForm3Data] = useState({
    residual_hazards: [],
    ppe_precautions: [],
    precaution_description: "",
  });

  console.log("work_permit_name", work_permit_name);

  const [checklist, setChecklist] = useState([]);

  // -------- APPROVE ----------
  const handleSaveClick = async () => {
    try {
      // Retrieve the authKey from localStorage
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        console.error("Authorization key not found");
        return;
      }

      // API call to approve the work permit
      const response = await axios.put(
        // `${API_URL}/api/approve_work_permit`,
        `${API_URL}/api/v2/fire_safety/approve`,
        { permit_id: permit_id, request_type: "new" }, // Send form_id in the request body
        {
          headers: {
            Authorization: authKey, // Pass the Authorization header
          },
        }
      );

      // Check the API response status
      if (response.status === 200) {
        console.log(response.data.message);
        setSeverity("success");
        showSnackbar("Work permit approved successfully!");
        setTimeout(() => {
          navigate("/work-permit-inspection");
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // -------- REJECT ----------
  const handleSaveRejectClick = async () => {
    const payload = {
      permit_id: permit_id, // Maps to `permit_id` in backend
      request_type: "new", // Set `request_type` as "new"
      reason: reason, // From the form input
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      // Make the API call
      const response = await axios.post(
        `${API_URL}/api/reject_permit`, // Ensure the method is POST
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        setTimeout(() => {
          navigate(`/cold-work-permit`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchChecklistIssuer = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const res = await axios.get(
        `${API_URL}/api/get_permit_checklist_items?permit_id=${permit_id}&identifier=issuer`,
        { headers: { Authorization: authKey } }
      );

      // Extract and flatten checklist items from categories
      const items = Object.values(res.data.checklistItems || {})
        .flat()
        .map((item) => {
          return {
            description: item.description,
            status: item.status, // 0 or 1 (unchecked/checked)
            // pick input field values if any
            inputs: (item.input_fields || []).map((f) => ({
              label: f.field_name,
              value: f.value || "",
            })),
          };
        });

      setChecklist(items);
    } catch (e) {
      console.error(e);
      alert("Failed to load checklist items");
    }
  };

  const fetchChecklist = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const res = await axios.get(
        `${API_URL}/api/get_permit_checklist_items?permit_id=${permit_id}&identifier=${"fire_safety_officer"}`,
        {
          headers: { Authorization: authKey },
        }
      );

      console.log(
        "res.data.get_permit_checklist_items",
        res.data.checklistItems
      );
      if (res.data.checklistItems) {
        processChecklist(res.data.checklistItems);
      } else {
        const fallback = await axios.get(
          `${API_URL}/api/get_checklist_item_descriptions?identifier=${"fire_safety_officer"}`,
          {
            params: { permit_type_id },
            headers: { Authorization: authKey },
          }
        );
        console.log(
          "res.data.get_checklist_item_descriptions",
          fallback.data.checklistItems
        );
        processChecklist(fallback.data.checklistItems, true);
        setIsNewChecklist(true);
      }
    } catch (e) {
      console.error(e);
      showSnackbar("Failed to load checklist items", "error");
    }
  };

  useEffect(() => {
    if (permit_id || permit_type_id) fetchChecklist();
    fetchChecklistIssuer();
  }, [permit_id, permit_type_id]);

  // Utility Functions
  const showSnackbar = (message, type = "success") => {
    setSnackbarMessage(message);
    setSeverity(type);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleCancelClick = () => {
    navigate("/work-permit-inspection");
  };

  // Form 1 Data Fetching (Read-only)
  const fetchForm1Data = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/get_permit_work_details/${permit_id}`,
        { headers: { Authorization: authKey } }
      );

      const permit = response.data.permit_details[0];
      setRequest_status(permit?.request_status);

      const dependentFieldValues = {};
      const dependentFieldsFromPermit =
        permit.issued_to?.dependent_fields || [];

      dependentFieldsFromPermit.forEach((dep) => {
        dependentFieldValues[dep.field_label] = dep.value;
      });

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return date;
      };

      setForm1Data({
        workPermitName: permit?.work_permit_name || "",
        formData: {
          permit_type_id: permit.permit_type_id,
          issued_to: permit.issued_to?.value || "",
          ...dependentFieldValues,
          department: permit.department_name,
          receiver_name: permit.receiver_name,
          area: permit.area,
          unit: permit.unit,
          work_description: permit.work_description,
          contractor: permit?.contractor || "",
          section: permit?.section || "",
        },
        dateValues: {
          "Start Date & Time": permit.valid_from
            ? formatDate(permit.valid_from)
            : null,
          "End Date & Time": permit.valid_to
            ? formatDate(permit.valid_to)
            : null,
        },
        equipmentDetails: permit?.equipment_details || [],
        dynamicSubFields: dependentFieldsFromPermit.map((dep) => ({
          id: dep.field_label,
          field_label: dep.field_label,
          field_name: dep.field_name,
          field_type: dep.field_type,
        })),
      });

      // Fetch fields for display
      if (permit.permit_type_id) {
        const fieldsResponse = await axios.get(
          `${API_URL}/api/get_permit_fields/${permit.permit_type_id}`,
          { headers: { Authorization: authKey } }
        );
        setForm1Data((prev) => ({
          ...prev,
          fields: fieldsResponse.data.fields || [],
        }));
      }
    } catch (error) {
      console.error("Failed to load Form 1 data", error);
    }
  };

  // Form 2 Functions (Interactive - Updated for proper dynamic field handling)
  const findItemById = (itemId) => {
    for (const cat of Object.values(checklistItems)) {
      const found = cat.find(
        (item) => item.id === itemId || item.checklist_item_id === itemId
      );
      if (found) return found;
    }
    return null;
  };

  const fetchDynamicInputFields = async (itemId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const item = findItemById(itemId);
      if (!item) return;

      const checklistDescId = item.checklist_item_id || item.id;
      const response = await axios.get(
        `${API_URL}/api/permit_checklist_input_fields/${checklistDescId}`,
        { headers: { Authorization: authKey } }
      );

      if (response.data && response.data.fields) {
        const textFields = response.data.fields.filter(
          (f) => f.field_type === "text"
        );
        const dropdownFields = response.data.fields.filter(
          (f) => f.field_type === "dropdown"
        );

        // Store dynamic fields
        setDynamicInputFields((prevState) => ({
          ...prevState,
          [itemId]: textFields,
        }));

        setDynamicDropdownFields((prevState) => ({
          ...prevState,
          [itemId]: dropdownFields,
        }));

        console.log(
          `Fetched ${textFields.length} text fields and ${dropdownFields.length} dropdown fields for item ${itemId}`
        );
      }
    } catch (error) {
      console.error("Error fetching dynamic input fields:", error);
      showSnackbar("Failed to load additional input fields", "error");
    }
  };

  const processExistingFields = (item) => {
    const itemId = item.id;
    const existingValues = {};

    // Process all existing field values from the item
    const fieldMapping = {
      h2s_gas: item.h2s_gas,
      o2_gas: item.o2_gas,
      hc_gas: item.hc_gas,
      lel_gas: item.lel_gas,
      toxic_gases: item.toxic_gases,
      vehicle_regd_no: item.vehicle_regd_no,
      electrical_permit_no: item.electrical_permit_no,
      equipment_status: item.equipment_status,
      permit_no: item.permit_no,
    };

    Object.entries(fieldMapping).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        existingValues[key] = value;
      }
    });

    // Process dynamic input fields if they exist
    if (item.input_fields && item.input_fields.length > 0) {
      const textFields = item.input_fields.filter(
        (f) => f.field_type === "text"
      );
      const dropdownFields = item.input_fields.filter(
        (f) => f.field_type === "dropdown"
      );

      if (textFields.length > 0) {
        setDynamicInputFields((prevState) => ({
          ...prevState,
          [itemId]: textFields,
        }));

        textFields.forEach((field) => {
          if (field.value) {
            existingValues[field.field_label] = field.value;
          }
        });
      }

      if (dropdownFields.length > 0) {
        setDynamicDropdownFields((prevState) => ({
          ...prevState,
          [itemId]: dropdownFields,
        }));

        const dropdownValues = {};
        dropdownFields.forEach((field) => {
          if (field.value) {
            if (field.is_multiple) {
              const values = field.value
                .split(", ")
                .map((val) => ({ value: val, label: val }));
              dropdownValues[field.field_label] = values;
            } else {
              dropdownValues[field.field_label] = {
                value: field.value,
                label: field.value,
              };
            }
          }
        });

        if (Object.keys(dropdownValues).length > 0) {
          setDynamicDropdownValues((prevState) => ({
            ...prevState,
            [itemId]: dropdownValues,
          }));
        }
      }
    }

    // Set all existing values
    if (Object.keys(existingValues).length > 0) {
      setDynamicInputValues((prevState) => ({
        ...prevState,
        [itemId]: existingValues,
      }));
    }
  };

  const handleRadioChange = async (itemId, value) => {
    setStatus((prevState) => ({
      ...prevState,
      [itemId]: value,
    }));

    if (value === "done") {
      // Always fetch dynamic fields when status changes to "done"
      await fetchDynamicInputFields(itemId);
    } else {
      // Clear dynamic fields when status changes to "not-required"
      setDynamicInputFields((prev) => {
        const newState = { ...prev };
        delete newState[itemId];
        return newState;
      });
      setDynamicDropdownFields((prev) => {
        const newState = { ...prev };
        delete newState[itemId];
        return newState;
      });
      setDynamicInputValues((prev) => {
        const newState = { ...prev };
        delete newState[itemId];
        return newState;
      });
      setDynamicDropdownValues((prev) => {
        const newState = { ...prev };
        delete newState[itemId];
        return newState;
      });
    }
  };

  const handleDynamicInputChange = (itemId, fieldLabel, value) => {
    setDynamicInputValues((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [fieldLabel]: value,
      },
    }));
  };

  const handleDynamicDropdownChange = (itemId, fieldLabel, selectedOption) => {
    setDynamicDropdownValues((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [fieldLabel]: selectedOption,
      },
    }));
  };

  const processChecklist = (items, isNew = false) => {
    const statusMap = {};

    Object.values(items).forEach((arr) =>
      arr.forEach((item) => {
        const itemId = item.id;

        // Set status based on existing data
        statusMap[itemId] = isNew
          ? "not-required"
          : item.status === 1
          ? "done"
          : "not-required";

        // If item has existing data and status is done, process existing fields
        if (!isNew && item.status === 1) {
          processExistingFields(item);
        }
      })
    );

    setChecklistItems(items);
    setStatus(statusMap);
  };

  // Form 3 Data Fetching (Read-only)
  const fetchForm3Data = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/get_hazard_precautions?permit_id=${permit_id}`,
        { headers: { Authorization: authKey } }
      );
      const hazardPrecaution = response.data.hazard_precautions?.[0];
      if (hazardPrecaution) {
        setForm3Data({
          residual_hazards: hazardPrecaution.residual_hazards || [],
          ppe_precautions: hazardPrecaution.ppe_precautions || [],
          precaution_description: hazardPrecaution.precaution_description || "",
        });
      }
    } catch (error) {
      console.error("Error fetching hazard precautions:", error);
    }
  };

  // Updated Save Form 2 to handle dynamic fields properly
  // const handleSaveForm2 = async () => {
  //   setIsLoading(true);
  //   try {
  //     const items = Object.values(checklistItems)
  //       .flat()
  //       .map((item) => {
  //         const itemId = item.id;
  //         const checklist_item_id = item.checklist_item_id || item.id;
  //         const statusValue = status[itemId] === "done" ? 1 : 0;

  //         const baseItem = {
  //           item_id: itemId,
  //           checklist_item_id,
  //           status: statusValue,
  //         };

  //         // Only add fields if status is "done"
  //         if (statusValue === 1) {
  //           // Get all dynamic input values for this item
  //           const itemInputValues = dynamicInputValues[itemId] || {};

  //           // Add all dynamic input field values
  //           Object.entries(itemInputValues).forEach(([fieldLabel, value]) => {
  //             if (value !== undefined && value !== "") {
  //               baseItem[fieldLabel] = value;
  //             }
  //           });

  //           // Get all dynamic dropdown values for this item
  //           const itemDropdownValues = dynamicDropdownValues[itemId] || {};

  //           // Add all dynamic dropdown field values
  //           Object.entries(itemDropdownValues).forEach(
  //             ([fieldLabel, selectedOption]) => {
  //               if (selectedOption) {
  //                 const dynamicDropdownFieldsForItem =
  //                   dynamicDropdownFields[itemId] || [];
  //                 const fieldMeta = dynamicDropdownFieldsForItem.find(
  //                   (f) => f.field_label === fieldLabel
  //                 );

  //                 if (fieldMeta?.is_multiple && Array.isArray(selectedOption)) {
  //                   baseItem[fieldLabel] = selectedOption
  //                     .map((opt) => opt.value)
  //                     .join(", ");
  //                 } else if (selectedOption.value) {
  //                   baseItem[fieldLabel] = selectedOption.value;
  //                 }
  //               }
  //             }
  //           );
  //         }

  //         return baseItem;
  //       });

  //     const authKey = localStorage.getItem("authKey");
  //     const payload = { permit_id, items };

  //     console.log("Saving payload:", payload);

  //     if (isNewChecklist) {
  //       await axios.post(`${API_URL}/api/add_permit_checklist_items`, payload, {
  //         headers: { Authorization: authKey },
  //       });
  //       setIsNewChecklist(false); // After first save, subsequent saves should be updates
  //     } else {
  //       await axios.put(
  //         `${API_URL}/api/update_permit_checklist_items`,
  //         payload,
  //         {
  //           headers: { Authorization: authKey },
  //         }
  //       );
  //     }

  //     fetchComplitionSatusData && fetchComplitionSatusData();
  //     showSnackbar("Checklist items saved successfully!", "success");

  //     // setTimeout(() => {
  //     //   navigate("/work-permit-inspection");
  //     // });
  //   } catch (error) {
  //     console.error("Error saving checklist items:", error);
  //     showSnackbar("Failed to save checklist items", "error");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSaveForm2 = async (isCombined = false) => {
    if (!isCombined) setIsLoading(true);

    try {
      const items = Object.values(checklistItems)
        .flat()
        .map((item) => {
          const itemId = item.id;
          const checklist_item_id = item.checklist_item_id || item.id;
          const statusValue = status[itemId] === "done" ? 1 : 0;

          const baseItem = {
            item_id: itemId,
            checklist_item_id,
            status: statusValue,
          };

          // Add dynamic input fields
          if (statusValue === 1 && dynamicInputValues[itemId]) {
            Object.entries(dynamicInputValues[itemId]).forEach(
              ([label, value]) => {
                baseItem[label] = value;
              }
            );
          }

          // Add dynamic dropdown fields
          if (statusValue === 1 && dynamicDropdownValues[itemId]) {
            Object.entries(dynamicDropdownValues[itemId]).forEach(
              ([label, selected]) => {
                if (Array.isArray(selected)) {
                  baseItem[label] = selected.map((x) => x.value).join(", ");
                } else if (selected?.value) {
                  baseItem[label] = selected.value;
                }
              }
            );
          }

          return baseItem;
        });

      const authKey = localStorage.getItem("authKey");
      const payload = { permit_id, items };

      if (isNewChecklist) {
        await axios.post(`${API_URL}/api/add_permit_checklist_items`, payload, {
          headers: { Authorization: authKey },
        });
        setIsNewChecklist(false);
      } else {
        await axios.put(
          `${API_URL}/api/update_permit_checklist_items`,
          payload,
          { headers: { Authorization: authKey } }
        );
      }

      if (!isCombined) showSnackbar("Checklist saved successfully!", "success");
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to save checklist.";

      showSnackbar(msg, "error");

      if (isCombined) throw error; // let parent handle
    } finally {
      if (!isCombined) setIsLoading(false);
    }
  };

  useEffect(() => {
    if (permit_id && permit_type_id) {
      fetchForm1Data();
      fetchForm3Data();
    }
  }, [permit_id, permit_type_id]);

  const handleSaveAndApprove = async () => {
    setIsLoading(true);

    try {
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        showSnackbar("Authorization key missing", "error");
        return;
      }

      // --- 1️⃣ SAVE CHECKLIST FIRST ---
      await handleSaveForm2(true); // pass flag = no snackbar + no loader end

      // --- 2️⃣ APPROVE PERMIT ---
      const approveRes = await axios.put(
        `${API_URL}/api/v2/fire_safety/approve`,
        { permit_id, request_type: "new" },
        { headers: { Authorization: authKey } }
      );

      if (approveRes.status === 200) {
        showSnackbar(
          "Checklist saved & permit approved successfully!",
          "success"
        );

        setTimeout(() => {
          navigate("/work-permit-inspection");
        }, 1000);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unexpected error occurred during approval.";

      showSnackbar(message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  // Render Form 1 (Read-only)
  const renderForm1 = () => (
    <Card
      sx={{
        mb: 3,
        borderRadius: 3,
        boxShadow: 4,
        height: "100%",
        overflowX: "scroll",
      }}
    >
      <CardContent sx={{ height: "100%" }}>
        <Typography
          variant="h6"
          component="h3"
          sx={{
            mb: 3,
            color: "primary.main",
            fontWeight: "bold",
            borderBottom: "2px solid",
            borderColor: "primary.light",
            pb: 1,
          }}
        >
          Work Permit Details
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <DetailItem label="Permit Type" value={form1Data.workPermitName} />
            <DetailItem
              label="Issued To"
              value={form1Data.formData.issued_to}
            />
            <DetailItem
              label="Department"
              value={form1Data.formData.department}
            />
            <DetailItem
              label="Receiver Name"
              value={form1Data.formData.receiver_name}
            />
            <DetailItem label="Area" value={form1Data.formData.area} />
            <DetailItem label="Unit" value={form1Data.formData.unit} />
          </Box>

          <Box
            sx={{
              backgroundColor: "grey.300",
              width: "1px",
              display: { xs: "none", md: "block" },
            }}
          />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <DetailItem label="Section" value={form1Data.formData.section} />
            <DetailItem
              label="Contractor"
              value={form1Data.formData.contractor}
            />
            <DetailItem
              label="Work Description"
              value={form1Data.formData.work_description}
            />
            <DetailItem
              label="Start Date & Time"
              value={
                form1Data.dateValues["Start Date & Time"]
                  ? form1Data.dateValues["Start Date & Time"].toLocaleString()
                  : "Not set"
              }
            />
            <DetailItem
              label="End Date & Time"
              value={
                form1Data.dateValues["End Date & Time"]
                  ? form1Data.dateValues["End Date & Time"].toLocaleString()
                  : "Not set"
              }
            />
          </Box>
        </Box>

        {form1Data.equipmentDetails.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Equipment Details:
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {form1Data.equipmentDetails.map((equipment, index) => (
                <Chip
                  key={index}
                  label={
                    equipment.TagNo ||
                    equipment.equipment_no ||
                    `Equipment ${index + 1}`
                  }
                  variant="outlined"
                  size="small"
                  color="primary"
                  style={{ marginBottom: "2px" }}
                />
              ))}
            </Stack>
          </Box>
        )}
      </CardContent>
    </Card>
  );

  const DetailItem = ({ label, value }) => (
    <Box>
      <Typography variant="subtitle2" color="textSecondary">
        {label}:
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontWeight: "500", color: "text.primary" }}
      >
        {value || "—"}
      </Typography>
    </Box>
  );

  // Updated Render Form 2 with proper dynamic field handling
  // const renderForm2 = () => (
  //   <Card sx={{ mb: 1 }}>
  //     <CardContent>
  //       <Typography
  //         variant="h6"
  //         component="h3"
  //         sx={{ mb: 1, color: "primary.main" }}
  //       >
  //         Checklist Items
  //       </Typography>

  //       <div className="checklist-container" style={{ padding: "0px" }}>
  //         {Object.keys(checklistItems).map((category) => (
  //           <Box key={category} sx={{ mb: 4 }}>
  //             <Typography
  //               variant="subtitle1"
  //               sx={{ mb: 2, fontWeight: "bold", color: "text.secondary" }}
  //             >
  //               {category}
  //             </Typography>

  //             {checklistItems[category].map((item) => (
  //               <Box
  //                 key={item.id}
  //                 className="checklist-item"
  //                 sx={{
  //                   mb: 3,
  //                   p: 2,
  //                   border: "1px solid #e0e0e0",
  //                   borderRadius: 1,
  //                 }}
  //               >
  //                 <Typography
  //                   variant="body1"
  //                   sx={{ mb: 1, fontWeight: "medium" }}
  //                 >
  //                   ({item.item_number}) {item.description}
  //                 </Typography>

  //                 <FormControl component="fieldset">
  //                   <RadioGroup
  //                     row
  //                     value={status[item.id] || "not-required"}
  //                     onChange={(e) =>
  //                       handleRadioChange(item.id, e.target.value)
  //                     }
  //                   >
  //                     <FormControlLabel
  //                       value="done"
  //                       control={<Radio />}
  //                       label="Done"
  //                     />
  //                     <FormControlLabel
  //                       value="not-required"
  //                       control={<Radio />}
  //                       label="Not Required"
  //                     />
  //                   </RadioGroup>
  //                 </FormControl>

  //                 {/* Dynamic Input Fields - Only when "done" */}
  //                 {status[item.id] === "done" &&
  //                   dynamicInputFields[item.id] && (
  //                     <Box sx={{ mt: 2 }}>
  //                       <Box
  //                         sx={{
  //                           display: "grid",
  //                           gridTemplateColumns: {
  //                             xs: "1fr",
  //                             md: "1fr 1fr",
  //                           },
  //                           gap: 2,
  //                         }}
  //                       >
  //                         {dynamicInputFields[item.id].map((field) => (
  //                           <TextField
  //                             key={field.field_label}
  //                             fullWidth
  //                             label={field.field_name}
  //                             placeholder={field.placeholder}
  //                             value={
  //                               dynamicInputValues[item.id]?.[
  //                                 field.field_label
  //                               ] || ""
  //                             }
  //                             onChange={(e) =>
  //                               handleDynamicInputChange(
  //                                 item.id,
  //                                 field.field_label,
  //                                 e.target.value
  //                               )
  //                             }
  //                             variant="outlined"
  //                             size="small"
  //                             required={field.is_required === 1}
  //                             multiline={field.is_multiline === 1}
  //                             rows={field.is_multiline === 1 ? 3 : 1}
  //                           />
  //                         ))}
  //                       </Box>
  //                     </Box>
  //                   )}

  //                 {/* Dynamic Dropdown Fields - Only when "done" */}
  //                 {status[item.id] === "done" &&
  //                   dynamicDropdownFields[item.id] && (
  //                     <Box sx={{ mt: 2 }}>
  //                       {dynamicDropdownFields[item.id].map((field) => {
  //                         const options =
  //                           field.options?.map((option) => ({
  //                             value: option,
  //                             label: option,
  //                           })) || [];

  //                         return (
  //                           <Box key={field.field_label} sx={{ mb: 2 }}>
  //                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
  //                               {field.field_name || field.placeholder}:
  //                             </Typography>
  //                             <Select
  //                               value={
  //                                 dynamicDropdownValues[item.id]?.[
  //                                   field.field_label
  //                                 ] || null
  //                               }
  //                               onChange={(option) =>
  //                                 handleDynamicDropdownChange(
  //                                   item.id,
  //                                   field.field_label,
  //                                   option
  //                                 )
  //                               }
  //                               options={options}
  //                               isClearable
  //                               placeholder={field.placeholder}
  //                               className="additional-dropdown-select"
  //                               isMulti={field.is_multiple === 1}
  //                             />
  //                           </Box>
  //                         );
  //                       })}
  //                     </Box>
  //                   )}
  //               </Box>
  //             ))}
  //           </Box>
  //         ))}
  //       </div>
  //     </CardContent>
  //   </Card>
  // );

  const renderForm2 = () => {
    const isDisabled = request_status !== "Pending Approval";

    return (
      <Card sx={{ mb: 1 }}>
        <CardContent>
          <Typography
            variant="h6"
            component="h3"
            sx={{ mb: 1, color: "primary.main" }}
          >
            Checklist Items
          </Typography>

          <div className="checklist-container" style={{ padding: "0px" }}>
            {Object.keys(checklistItems).map((category) => (
              <Box key={category} sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, fontWeight: "bold", color: "text.secondary" }}
                >
                  {category}
                </Typography>

                {checklistItems[category].map((item) => (
                  <Box
                    key={item.id}
                    className="checklist-item"
                    sx={{
                      mb: 3,
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ mb: 1, fontWeight: "medium" }}
                    >
                      ({item.item_number}) {item.description}
                    </Typography>

                    {/* Disable Radio Group */}
                    <FormControl component="fieldset" disabled={isDisabled}>
                      <RadioGroup
                        row
                        value={status[item.id] || "not-required"}
                        onChange={(e) =>
                          handleRadioChange(item.id, e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="done"
                          control={<Radio />}
                          label="Done"
                        />
                        <FormControlLabel
                          value="not-required"
                          control={<Radio />}
                          label="Not Required"
                        />
                      </RadioGroup>
                    </FormControl>

                    {/* Dynamic Text Fields */}
                    {status[item.id] === "done" &&
                      dynamicInputFields[item.id] && (
                        <Box sx={{ mt: 2 }}>
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                              gap: 2,
                            }}
                          >
                            {dynamicInputFields[item.id].map((field) => (
                              <TextField
                                key={field.field_label}
                                fullWidth
                                disabled={isDisabled}
                                label={field.field_name}
                                placeholder={field.placeholder}
                                value={
                                  dynamicInputValues[item.id]?.[
                                    field.field_label
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleDynamicInputChange(
                                    item.id,
                                    field.field_label,
                                    e.target.value
                                  )
                                }
                                variant="outlined"
                                size="small"
                                required={field.is_required === 1}
                                multiline={field.is_multiline === 1}
                                rows={field.is_multiline === 1 ? 3 : 1}
                              />
                            ))}
                          </Box>
                        </Box>
                      )}

                    {/* Dynamic Dropdown Fields */}
                    {status[item.id] === "done" &&
                      dynamicDropdownFields[item.id] && (
                        <Box sx={{ mt: 2 }}>
                          {dynamicDropdownFields[item.id].map((field) => {
                            const options =
                              field.options?.map((option) => ({
                                value: option,
                                label: option,
                              })) || [];

                            return (
                              <Box key={field.field_label} sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                  {field.field_name || field.placeholder}:
                                </Typography>

                                <Select
                                  isDisabled={isDisabled}
                                  value={
                                    dynamicDropdownValues[item.id]?.[
                                      field.field_label
                                    ] || null
                                  }
                                  onChange={(option) =>
                                    handleDynamicDropdownChange(
                                      item.id,
                                      field.field_label,
                                      option
                                    )
                                  }
                                  options={options}
                                  isClearable
                                  placeholder={field.placeholder}
                                  className="additional-dropdown-select"
                                  isMulti={field.is_multiple === 1}
                                />
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                  </Box>
                ))}
              </Box>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  };

  const renderForm3 = () => (
    <Card
      sx={{
        mb: 3,
        borderRadius: 3,
        boxShadow: 3,
        height: "100%",
        overflow: "hidden", // ✅ remove extra scroll
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "auto", // ✅ single scroll only when needed
          "&::-webkit-scrollbar": { display: "none" }, // ✅ hide scrollbar
          scrollbarWidth: "none", // for Firefox
        }}
      >
        <Typography
          variant="h6"
          component="h3"
          sx={{
            mb: 3,
            color: "primary.main",
            fontWeight: "bold",
            borderBottom: "2px solid",
            borderColor: "primary.light",
            pb: 1,
          }}
        >
          Hazards & Precautions
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1px 1fr" },
            flexGrow: 1,
            gap: 2,
          }}
        >
          {/* Residual Hazards */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="subtitle2" color="textSecondary">
              Residual Hazards:
            </Typography>
            {form3Data.residual_hazards.length > 0 ? (
              <Box
                component="ul"
                sx={{
                  listStyle: "none", // ✅ remove dots
                  p: 0,
                  m: 0,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {form3Data.residual_hazards.map((hazard, index) => (
                  <li key={index}>
                    <Chip
                      label={hazard}
                      variant="outlined"
                      size="small"
                      color="primary"
                    />
                  </li>
                ))}
              </Box>
            ) : (
              <Typography variant="body1">
                No residual hazards selected
              </Typography>
            )}
          </Box>

          {/* Vertical Divider */}
          <Box
            sx={{
              backgroundColor: "grey.300",
              width: "1px",
              display: { xs: "none", md: "block" },
            }}
          />

          {/* PPE Precautions */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="subtitle2" color="textSecondary">
              PPE Precautions:
            </Typography>
            {form3Data.ppe_precautions.length > 0 ? (
              <Box
                component="ul"
                sx={{
                  listStyle: "none", // ✅ remove dots
                  p: 0,
                  m: 0,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {form3Data.ppe_precautions.map((ppe, index) => (
                  <li key={index}>
                    <Chip
                      label={ppe}
                      variant="outlined"
                      size="small"
                      color="primary"
                    />
                  </li>
                ))}
              </Box>
            ) : (
              <Typography variant="body1">
                No PPE precautions selected
              </Typography>
            )}
          </Box>
        </Box>

        {/* Full-width description at bottom */}
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
            Additional Precaution Description:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              p: 2,
              backgroundColor: "#f5f5f5",
              borderRadius: 1,
              whiteSpace: "pre-wrap",
              minHeight: "60px",
            }}
          >
            {form3Data.precaution_description || "No additional description"}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  const handleGenratePermit = (permit_id, work_permit_name, wp_status) => {
    console.log("ID:", permit_id); // Log the ID
    // navigate(`/cold-work-permit-inspection-view/${id}`);
    navigate(`/view-pdf-formate/${permit_id}/${work_permit_name}/${wp_status}`);
  };

  return (
    <div
      className={`data-list-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="data-form-content">
        <div className="data-form-header">
          <div className="data-form-header-content">
            <div className="data-form-heading-content-left-side">
              <IoArrowBackCircle
                style={{ color: "#233b80", paddingTop: "3px" }}
                size={25}
                onClick={handleCancelClick}
              />
              <span className="data-form-heading-text">Work Permit View</span>
            </div>
          </div>
        </div>
        <Divider />

        <div className="data-form-body-permit-fands">
          <Box
            sx={{
              width: "100%",
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Top row → Work Permit + Hazards side by side */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 3,
              }}
            >
              <Box sx={{ flex: 1 }}>{renderForm1()}</Box>

              <Box sx={{ flex: 1 }}>{renderForm3()}</Box>
            </Box>

            <Card
              sx={{
                mb: 3,
                borderRadius: 3,
                boxShadow: 3,
                padding: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    // fontSize: "16px",
                    fontWeight: 500,
                    color: "#1976d2",
                    mb: 2,
                  }}
                >
                  Checklist Items (Issuer)
                </Typography>

                <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                  {checklist.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "12px",
                        padding: "8px 10px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        background: "#fafafa",
                      }}
                    >
                      <Typography variant="body2">
                        {item.description}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ ml: 1, color: "gray", fontSize: "13px" }}
                      >
                        — Status:{" "}
                        <span
                          style={{ color: item.status === 1 ? "green" : "red" }}
                        >
                          {item.status === 1 ? "Done" : "Not Required"}
                        </span>
                      </Typography>

                      {item.inputs.length > 0 && (
                        <div style={{ marginTop: "6px" }}>
                          {item.inputs.map((input, i) => (
                            <Chip
                              key={i}
                              label={`${input.label}: ${
                                input.value || "Not Filled"
                              }`}
                              variant="outlined"
                              size="small"
                              color="primary"
                              sx={{ mr: 0.5, mb: 0.5 }}
                            />
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            {work_permit_name === "Hot Work" ||
            work_permit_name === "Confined Space"
              ? renderForm2()
              : null}
          </Box>
        </div>

        <div className="footer">
          <div className="button-group">
            <button
              className="data-form-cancel-button"
              onClick={handleCancelClick}
            >
              Cancel
            </button>

            {work_permit_name === "Hot Work" &&
              request_status === "Pending Approval" && (
                <>
                  <button
                    className="data-form-next-button"
                    disabled={isLoading}
                    onClick={handleSaveAndApprove}
                    style={{ marginRight: "10px" }}
                  >
                    {isLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Save & Approve"
                    )}
                  </button>

                  <button
                    className="data-form-reject-button"
                    type="button"
                    onClick={() => setShowRejectPopup(true)}
                  >
                    Reject
                  </button>
                </>
              )}

            {work_permit_name === "Cold Work" &&
              request_status === "Pending Approval" && (
                <>
                  <button
                    style={{ marginLeft: "10px" }}
                    className="data-form-save-button approverd-button-permit approve_btn_clr"
                    type="button"
                    onClick={handleApproveConfirm}
                  >
                    Approve
                  </button>

                  <button
                    className="data-form-reject-button"
                    type="button"
                    onClick={() => setShowRejectPopup(true)}
                  >
                    Reject
                  </button>
                </>
              )}

            {work_permit_name === "Confined Space" &&
              request_status === "Pending Approval" && (
                <>
                  <button
                    className="data-form-next-button"
                    disabled={isLoading}
                    onClick={handleSaveAndApprove}
                    style={{ marginRight: "10px" }}
                  >
                    {isLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Save & Approve"
                    )}
                  </button>

                  <button
                    className="data-form-reject-button"
                    type="button"
                    onClick={() => setShowRejectPopup(true)}
                  >
                    Reject
                  </button>
                </>
              )}

            {/* {work_permit_name === "Hot Work" ? (
              <button
                className="data-form-next-button"
                onClick={handleSaveForm2}
                disabled={isLoading}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save"
                )}
              </button>
            ) : null}

            {request_status === "Pending Approval" ? (
              <>
                <button
                  className="data-form-next-button"
                  disabled={isLoading}
                  onClick={handleSaveAndApprove}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px 20px",
                    cursor: isLoading ? "not-allowed" : "pointer",
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Save & Approve"
                  )}
                </button>

                <button
                  style={{ marginLeft: "10px" }}
                  className="data-form-save-button approverd-button-permit"
                  type="button"
                  onClick={handleApproveConfirm}
                >
                  Approve
                </button>

                <button
                  className="data-form-reject-button"
                  type="button"
                  onClick={() => setShowRejectPopup(true)}
                >
                  Reject
                </button>
              </>
            ) : null} */}
          </div>

          {/* APPROVE CONFIRM POPUP */}
          {isApprovePopupOpen && (
            <div className="permit-approval-popup">
              <div className="permit-approval-popup-content">
                <div className="approval-popup-header">Confirm Approval</div>
                <p className="approval-popup-message">
                  Are you sure you want to approve this permit?
                </p>
                <div className="approval-popup-buttons">
                  <button className="approve-button approve_btn_clr" onClick={confirmApprove}>
                    Yes, Approve
                  </button>
                  <button className="cancel-button" onClick={closeApprovePopup}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* REJECT CONFIRM POPUP */}
          {showRejectPopup && (
            <div className="confirm-delete-popup">
              <div className="confirm-delete-popup-content">
                <div className="confirm-model">
                  <div className="confirm-model-content">
                    <div className="confirm-model-content-body">
                      <p>Are you sure you want to reject this request?</p>
                    </div>
                    <div className="confirm-model-content-footer">
                      <button
                        className="reject-confirm-button"
                        onClick={handleRejectConfirm}
                      >
                        Yes, Reject
                      </button>
                      <button
                        className="reject-cancel-button"
                        onClick={() => setShowRejectPopup(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* REJECT REASON POPUP */}
          {isPopupOpen && (
            <div className="permit-popup-model">
              <div className="form-permit-popup-content">
                <div className="reminder-popup-model-header">
                  <div className="reminder-popup-model-content-header">
                    <div className="reminder-popup-model-content-header-left-part">
                      Reject Permit
                    </div>
                    <div className="reminder-popup-model-content-header-right-part"></div>
                  </div>

                  <div className="permit-popup-new-form">
                    <form className="permit-popup-form-detail">
                      <div className="new-data-form">
                        <div className="new-form-group email-filed">
                          <label htmlFor="reason">
                            Reason for rejection
                            <span className="text-danger">*</span>
                          </label>

                          <div className="input-group">
                            <textarea
                              id="reason"
                              name="reason"
                              placeholder="Enter reason"
                              value={reason}
                              onChange={handleReasonChange}
                              rows="4"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="footers">
                    <div className="form-button-group">
                      <button
                        className="form-reject-button"
                        onClick={handleSaveRejectClick}
                        disabled={isLoading}
                      >
                        {isLoading ? "Rejecting" : "Reject"}
                      </button>

                      <button
                        className="person-user-cancel-button"
                        onClick={closePopup}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            onClose={handleSnackbarClose}
            severity={severity}
            variant="filled"
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    </div>
  );
}

export default PermitViewPage;
